window.productItemSlider = (() => {

  const observed_elements = new WeakSet();
  let mutation_timer;

  const is_touch_device = window.matchMedia('(hover: none)').matches;

  const loadSlideImage = (slide) => {
    const img = slide.querySelector('img[data-src]');
    if (!img) return;

    slide.querySelectorAll('source[data-srcset]').forEach(source => {
      source.srcset = source.dataset.srcset;
    });

    img.src = img.dataset.src;
    img.removeAttribute('data-src');
  };

  const initSlider = (product_item) => {
    if (product_item.classList.contains('product-item--slider-activated')) return;

    const slider_el = product_item.querySelector('[data-product-slider]');
    const track = product_item.querySelector('[data-slider-track]');
    const dots_container = product_item.querySelector('[data-slider-dots]');
    if (!track) return;

    const slides = [...track.querySelectorAll('[data-slide]')];
    if (slides.length <= 1) return;

    const slide_time = parseInt(slider_el?.dataset.slideTime) || 3000;
    const transition_speed = parseInt(slider_el?.dataset.transitionSpeed) || 350;

    let current_index = 0;
    let autoplay_timer;
    let touch_start_x = 0;
    let pointer_start_x = 0;
    let prevent_next_click = false;

    const savePosition = () => {
      product_item.dataset.currentSlide = current_index;
    };

    const updateDots = () => {
      if (!dots_container) return;
      dots_container.querySelectorAll('.product-item__slider-dot').forEach((dot, i) => {
        dot.classList.toggle('is-active', i === current_index);
      });
    };

    const getSlideWidth = () => slider_el.getBoundingClientRect().width;

    const goToSlide = (index) => {
      current_index = (index + slides.length) % slides.length;
      track.style.transform = `translateX(${-current_index * getSlideWidth()}px)`;
      loadSlideImage(slides[current_index]);
      loadSlideImage(slides[(current_index + 1) % slides.length]);
      updateDots();
      savePosition();
    };

    const goToSaved = () => {
      const saved = parseInt(product_item.dataset.currentSlide) || 1;
      current_index = saved;
      track.style.transition = 'none';
      track.style.transform = `translateX(${-current_index * getSlideWidth()}px)`;
      loadSlideImage(slides[current_index]);
      loadSlideImage(slides[(current_index + 1) % slides.length]);
      updateDots();
      requestAnimationFrame(() => {
        track.style.transition = `transform ${transition_speed}ms ease`;
      });
    };

    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'product-item__slider-dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', `Slide ${i + 1}`);
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        goToSlide(i);
        stopAutoplay();
        startAutoplay();
      });
      dots_container?.appendChild(dot);
    });

    const startAutoplay = () => {
      autoplay_timer = setInterval(() => goToSlide(current_index + 1), slide_time);
    };

    const stopAutoplay = () => clearInterval(autoplay_timer);

    const image_wrapper = product_item.querySelector('.product-item__image-wrapper');

    image_wrapper?.addEventListener('mouseenter', () => {
      if (is_touch_device) return;
      goToSaved();
      startAutoplay();
    });

    image_wrapper?.addEventListener('mouseleave', () => {
      if (is_touch_device) return;
      stopAutoplay();
    });

    image_wrapper?.addEventListener('touchstart', (e) => {
      touch_start_x = e.touches[0].clientX;
      document.querySelectorAll('.product-item--slider-active').forEach(el => {
        if (el !== product_item) el.classList.remove('product-item--slider-active');
      });
    }, { passive: true });

    image_wrapper?.addEventListener('touchend', (e) => {
      const delta = touch_start_x - e.changedTouches[0].clientX;
      if (Math.abs(delta) > 40) {
        product_item.classList.add('product-item--slider-active');
        goToSlide(delta > 0 ? current_index + 1 : current_index - 1);
        stopAutoplay();
        startAutoplay();
        prevent_next_click = true;
      }
    }, { passive: true });

    image_wrapper?.addEventListener('click', (e) => {
      if (prevent_next_click) {
        e.preventDefault();
        prevent_next_click = false;
      }
    });

    const prev_btn = product_item.querySelector('[data-slider-prev]');
    const next_btn = product_item.querySelector('[data-slider-next]');

    prev_btn?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      goToSlide(current_index - 1);
      stopAutoplay();
      startAutoplay();
    });

    next_btn?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      goToSlide(current_index + 1);
      stopAutoplay();
      startAutoplay();
    });

    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse') return;
      pointer_start_x = e.clientX;
      track.setPointerCapture(e.pointerId);
      e.preventDefault();
    });

    track.addEventListener('pointerup', (e) => {
      if (e.pointerType !== 'mouse') return;
      const delta = pointer_start_x - e.clientX;
      if (Math.abs(delta) > 40) {
        goToSlide(delta > 0 ? current_index + 1 : current_index - 1);
        stopAutoplay();
        startAutoplay();
        prevent_next_click = true;
      }
    });

    slider_el.addEventListener('click', (e) => {
      if (prevent_next_click) {
        e.preventDefault();
        e.stopPropagation();
        prevent_next_click = false;
      }
    });

    loadSlideImage(slides[0]);
    loadSlideImage(slides[1]);

    track.style.transition = 'none';
    track.style.transform = `translateX(${-current_index * getSlideWidth()}px)`;
    requestAnimationFrame(() => {
      track.style.transition = `transform ${transition_speed}ms ease`;
    });

    product_item._slider_cleanup = () => stopAutoplay();

    product_item.classList.add('product-item--slider-activated');
  };

  const visibility_observer = new IntersectionObserver((entries) => {
    entries.forEach(({ isIntersecting, target }) => {
      if (!isIntersecting) return;
      initSlider(target);
      visibility_observer.unobserve(target);
    });
  }, { threshold: 0.1, rootMargin: '150px 0px' });

  const observeNewSliders = () => {
    const selector = '.product-item--slider-available:not(.product-item--slider-activated)';
    document.querySelectorAll(selector).forEach(el => {
      if (observed_elements.has(el)) return;
      observed_elements.add(el);
      visibility_observer.observe(el);
    });
  };

  const removeSlider = (product_item) => {
    product_item._slider_cleanup?.();
    product_item.classList.remove('product-item--slider-activated');
    product_item.classList.remove('product-item--slider-active');
    const track = product_item.querySelector('[data-slider-track]');
    if (track) track.style.transform = '';
    const dots = product_item.querySelector('[data-slider-dots]');
    if (dots) dots.innerHTML = '';
  };

  const mutation_observer = new MutationObserver(() => {
    clearTimeout(mutation_timer);
    mutation_timer = setTimeout(observeNewSliders, 80);
  });

  mutation_observer.observe(document.body, { childList: true, subtree: true });

  const init = () => {
    observeNewSliders();
  };

  const regenerate = () => {
    document.querySelectorAll('.product-item--slider-activated').forEach(removeSlider);
    observeNewSliders();
  };

  const remove = () => {
    visibility_observer.disconnect();
    mutation_observer.disconnect();
    document.querySelectorAll('.product-item--slider-activated').forEach(removeSlider);
  };

  init();

  return { init, regenerate, remove };

})();


document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-store-info-trigger]');
  if (!trigger) return;
  e.preventDefault();
  const realLink = document.querySelector('.store-availability__information-link');
  if (realLink) realLink.click();
});


window.shopTheLook = (() => {

  const HTML_OPEN_CLASS = 'shop-the-look-open';
  const FOCUS_TRAP_HELPER_ATTR = 'data-shop-the-look-focus-helper';
  const CART_REFRESH_TIMEOUT_MS = 2000;

  const openModal = (id) => {
    const modal = document.getElementById(id);
    if (!modal) return;
    modal.removeAttribute('hidden');
    modal.classList.add('is-open');
    document.documentElement.classList.add(HTML_OPEN_CLASS);
  };

  const closeModal = (modal) => {
    if (!modal) return;
    modal.setAttribute('hidden', '');
    modal.classList.remove('is-open');
    if (!document.querySelector('.shop-the-look-modal.is-open')) {
      document.documentElement.classList.remove(HTML_OPEN_CLASS);
    }
  };

  const buildItemsPayload = (container) => {
    const slots = {};
    container.querySelectorAll('input[name^="items["]').forEach((input) => {
      const match = input.name.match(/^items\[(\d+)\]\[(\w+)\]$/);
      if (!match) return;
      const [, idx, prop] = match;
      slots[idx] = slots[idx] || {};
      slots[idx][prop] = prop === 'quantity' ? parseInt(input.value, 10) || 1 : input.value;
    });
    return Object.keys(slots)
      .sort((a, b) => Number(a) - Number(b))
      .map((k) => slots[k])
      .filter((item) => item && item.id);
  };

  const ensureFocusTrapHelper = () => {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    if (drawer.querySelector(`[${FOCUS_TRAP_HELPER_ATTR}]`)) return;

    const helper = document.createElement('button');
    helper.type = 'button';
    helper.setAttribute(FOCUS_TRAP_HELPER_ATTR, '');
    helper.tabIndex = 0;
    helper.style.cssText = [
      'position:absolute',
      'left:-9999px',
      'top:auto',
      'width:1px',
      'height:1px',
      'padding:0',
      'margin:0',
      'border:0',
      'overflow:hidden',
    ].join(';');
    drawer.appendChild(helper);
  };

  const waitForThemeCartRefresh = () => new Promise((resolve) => {
    const handler = () => {
      document.removeEventListener('flu:cart:updated', handler);
      resolve();
    };
    document.addEventListener('flu:cart:updated', handler);
    setTimeout(() => {
      document.removeEventListener('flu:cart:updated', handler);
      resolve();
    }, CART_REFRESH_TIMEOUT_MS);
  });

  const isCartDrawerOpen = () => {
    const drawer = document.querySelector('[data-cart-drawer]');
    return Boolean(drawer && drawer.classList.contains('is-visible'));
  };

  const openCartDrawer = () => {
    if (isCartDrawerOpen()) return;
    ensureFocusTrapHelper();
    const toggle = document.querySelector('.js-cart-drawer-toggle');
    if (toggle) toggle.click();
  };

  const refreshThenOpenCartDrawer = async () => {
    const refreshDone = waitForThemeCartRefresh();
    document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
    await refreshDone;
    openCartDrawer();
  };

  const closeCartDrawer = () => {
    if (!isCartDrawerOpen()) return;

    const closeBtn = document.querySelector('[data-cart-drawer] .js-close');
    if (closeBtn) {
      closeBtn.click();
      return;
    }

    window.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', keyCode: 27 }));
  };


  const handleClick = (event) => {
    const trigger = event.target.closest('[data-shop-the-look-trigger]');
    if (trigger) {
      event.preventDefault();
      openModal(trigger.getAttribute('data-shop-the-look-target'));
      return;
    }
    const closer = event.target.closest('[data-shop-the-look-close]');
    if (closer) {
      event.preventDefault();
      closeModal(closer.closest('.shop-the-look-modal'));
    }
  };

  const handleKeydown = (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.shop-the-look-modal.is-open').forEach(closeModal);
  };

  const handleAddToCartClick = async (event) => {
    const submitButton = event.target.closest('[data-shop-the-look-submit]');
    if (!submitButton) return;
    event.preventDefault();

    const container = submitButton.closest('[data-shop-the-look-form]');
    if (!container) return;

    submitButton.disabled = true;
    submitButton.classList.add('bttn--loading');

    try {
      const items = buildItemsPayload(container);
      if (items.length === 0) throw new Error('No items to add');

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ items }),
      });

      if (!response.ok) {
        const error_payload = await response.json().catch(() => ({}));
        throw new Error(error_payload.description || error_payload.message || 'Add to cart failed');
      }

      await refreshThenOpenCartDrawer();
      closeModal(container.closest('.shop-the-look-modal'));
    } catch (err) {
      console.error('Shop the look add to cart failed:', err);
    } finally {
      submitButton.disabled = false;
      submitButton.classList.remove('bttn--loading');
    }
  };

  const init = () => {
    document.addEventListener('click', handleClick);
    document.addEventListener('click', handleAddToCartClick);
    document.addEventListener('keydown', handleKeydown);
  };

  const remove = () => {
    document.removeEventListener('click', handleClick);
    document.removeEventListener('click', handleAddToCartClick);
    document.removeEventListener('keydown', handleKeydown);
  };

  init();

  return {
    init,
    remove,
    openDrawer: openCartDrawer,
    closeDrawer: closeCartDrawer,
  };

})();

/*
 * u-cart-drawer — custom-element cart drawer
 *
 * Conventions (per project style):
 *   - top-level helpers are arrow functions
 *   - variables in snake_case, functions in camelCase
 *   - BEM classes (.ucdrawer__*) for styling
 *
 * Public API (exposed at the bottom):
 *   window.uCartDrawer.open()
 *   window.uCartDrawer.close()
 *   window.uCartDrawer.update()
 */

window.uCartDrawer = (() => {

  // ---------- constants ----------

  const tag_name = 'u-cart-drawer';
  const html_open_class = 'ucdrawer-open';
  const recommendations_endpoint = '/recommendations/products.json';
  const recommendations_limit = 8;
  const recommendations_intent = 'related';

  // Identifies fetch calls originating from this drawer itself so the cart
  // mutation watcher (below) skips them — we already call `update()` at the
  // right moment in our own code and don't want to double-fire.
  const internal_header_name = 'X-uCartDrawer-Internal';
  const internal_header_value = '1';

  // ---------- cart mutation watcher (fetch monkey-patch) ----------
  //
  // Shopify themes have no built-in "the cart changed" event. The widely-used
  // pattern (Dawn, Studio, etc.) is to wrap `window.fetch` and react to writes
  // hitting the Ajax Cart API:
  //   POST /cart/add(.js)            → ADD       → drawer open() + update()
  //   POST /cart/change(.js)         → CHANGE    → drawer update()
  //   POST /cart/update(.js)         → UPDATE    → drawer update()
  //   POST /cart/clear(.js)          → CLEAR     → drawer update()
  // We don't intercept GET /cart.js (it's a read).

  const cart_add_regex = /\/cart\/add(\.js)?(\?|$)/i;
  const cart_change_regex = /\/cart\/(change|update|clear)(\.js)?(\?|$)/i;

  const requestUrl = (input) => {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    if (input instanceof URL) return input.toString();
    return '';
  };

  const hasInternalHeader = (input, init) => {
    // Check init.headers first (most common path).
    const headers = init && init.headers;
    if (headers) {
      if (typeof Headers !== 'undefined' && headers instanceof Headers) {
        if (headers.get(internal_header_name) === internal_header_value) return true;
      } else if (typeof headers === 'object') {
        for (const key of Object.keys(headers)) {
          if (key.toLowerCase() === internal_header_name.toLowerCase()
              && String(headers[key]) === internal_header_value) {
            return true;
          }
        }
      }
    }
    // Request object passed as `input`.
    if (input && typeof input.headers === 'object' && typeof input.headers.get === 'function') {
      if (input.headers.get(internal_header_name) === internal_header_value) return true;
    }
    return false;
  };

  // Detects a Shopify-shape cart error inside the response body. Even when
  // the HTTP status is 2xx (some apps / theme wrappers do this), the body
  // may look like { "status": 422, "description": "..." } — that means the
  // mutation actually failed (inventory exceeded, sold out, etc.) and we
  // must NOT open / refresh the drawer.
  const isShopifyCartError = (body) => {
    if (!body || typeof body !== 'object') return false;
    const status = Number(body.status);
    if (Number.isFinite(status) && status >= 400) return true;
    // Some errors only carry `description` + `message` without `status`.
    if (body.description && body.message && !body.items && !body.id) return true;
    return false;
  };

  // Triggers the drawer's reaction once we know a mutation HTTP call
  // succeeded. Deferred one tick so the original caller's `.then()` runs
  // first — they often need the response body before our re-render fires.
  const reactToCartMutation = (kind) => {
    setTimeout(() => {
      const api = window.uCartDrawer;
      if (!api) return;
      api.update().then(() => {
        if (kind === 'add') {
          api.open();
          // The newly-added item lands at the top of the list. Scroll the
          // body up so the user sees it (covers the quick-shop modal flow,
          // PDP add-to-cart, and any other external POST /cart/add.js).
          api.scrollBodyToTop();
        }
      }).catch(() => {});
    }, 0);
  };

  if (!window.__uCartDrawerFetchPatched) {
    window.__uCartDrawerFetchPatched = true;
    const original_fetch = window.fetch.bind(window);

    window.fetch = function (input, init) {
      const url = requestUrl(input);
      const internal = hasInternalHeader(input, init);
      const is_add = !internal && cart_add_regex.test(url);
      const is_change = !internal && cart_change_regex.test(url);

      const result = original_fetch(input, init);

      if (is_add || is_change) {
        result.then(async (response) => {
          if (!response.ok) return;
          // Some apps / proxies return HTTP 200 with `{ "status": 422, ... }`
          // in the JSON body for "soft" errors (out of stock, etc.). Peek the
          // body via a clone so the caller still gets the original stream.
          try {
            const body = await response.clone().json();
            if (isShopifyCartError(body)) return;
          } catch (_) {
            // Non-JSON response — fall through and react normally.
          }
          reactToCartMutation(is_add ? 'add' : 'change');
        }).catch(() => {
          // Network errors are the caller's problem — we just don't react.
        });
      }

      return result;
    };
  }

  // XMLHttpRequest interception — covers legacy apps that use jQuery.ajax,
  // axios with XHR adapter, or hand-rolled XHR. Browsers expose URL on the
  // instance only after `open()` is called, so we capture it there and react
  // in the `load` listener once the response arrives.
  if (!window.__uCartDrawerXhrPatched && typeof window.XMLHttpRequest !== 'undefined') {
    window.__uCartDrawerXhrPatched = true;
    const original_open = window.XMLHttpRequest.prototype.open;
    const original_setRequestHeader = window.XMLHttpRequest.prototype.setRequestHeader;

    window.XMLHttpRequest.prototype.open = function (method, url) {
      // Stash metadata on the instance so the load handler can read it.
      this.__ucdMethod = String(method || '').toUpperCase();
      this.__ucdUrl = String(url || '');
      this.__ucdInternal = false;
      return original_open.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.setRequestHeader = function (header, value) {
      if (String(header).toLowerCase() === internal_header_name.toLowerCase()
          && String(value) === internal_header_value) {
        this.__ucdInternal = true;
      }
      return original_setRequestHeader.apply(this, arguments);
    };

    const xhr_proto = window.XMLHttpRequest.prototype;
    const original_send = xhr_proto.send;

    xhr_proto.send = function () {
      if (this.__ucdMethod === 'POST' && !this.__ucdInternal) {
        const is_add = cart_add_regex.test(this.__ucdUrl);
        const is_change = cart_change_regex.test(this.__ucdUrl);
        if (is_add || is_change) {
          this.addEventListener('load', () => {
            if (this.status < 200 || this.status >= 300) return;
            // Same defensive check as the fetch path — apps / theme wrappers
            // sometimes return 200 with a Shopify-shape error in the body.
            try {
              const body = JSON.parse(this.responseText);
              if (isShopifyCartError(body)) return;
            } catch (_) { /* not JSON, treat as success */ }
            reactToCartMutation(is_add ? 'add' : 'change');
          });
        }
      }
      return original_send.apply(this, arguments);
    };
  }

  // ---------- money formatting ----------

  // Price formatting using cart.currency (the active market's ISO code from
  // /cart.js). `Intl.NumberFormat` with `currencyDisplay: 'code'` outputs the
  // ISO code ("PLN", "EUR", "USD") instead of the locale-bound symbol ("zł",
  // "€", "$") — so what we render in the drawer matches what Shopify stores
  // know the currency as, regardless of the visitor's browser locale.
  // Cart prices come in cents — we always divide by 100 first.
  const formatMoney = (cents, money_format, currency_code) => {
    const value = Number(cents) / 100;

    const currency = currency_code
      || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active);

    if (currency) {
      const locale = document.documentElement.lang || navigator.language || 'en';
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
          currencyDisplay: 'code',
        }).format(value);
      } catch (_) { /* fall through */ }
    }

    // No currency known — fall back to `shop.money_format` placeholder
    // expansion. This keeps the drawer usable even before the first cart
    // fetch resolves.
    if (money_format) {
      const placeholder = money_format.match(/\{\{\s*(\w+)\s*\}\}/);
      if (placeholder) {
        let formatted;
        switch (placeholder[1]) {
          case 'amount':
          case 'amount_with_comma_separator':
            formatted = value.toFixed(2).replace('.', ',');
            break;
          case 'amount_no_decimals':
          case 'amount_no_decimals_with_comma_separator':
            formatted = Math.round(value).toString();
            break;
          case 'amount_with_space_separator':
            formatted = value
              .toFixed(2)
              .replace('.', ',')
              .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
            break;
          case 'amount_no_decimals_with_space_separator':
            formatted = Math.round(value)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
            break;
          default:
            formatted = value.toFixed(2);
        }
        return money_format.replace(placeholder[0], formatted);
      }
    }

    return value.toFixed(2);
  };

  // ---------- cart API ----------

  const fetchCart = async () => {
    const response = await fetch('/cart.js', {
      method: 'GET',
      credentials: 'include',
      headers: { 'Accept': 'application/json' },
    });
    if (!response.ok) throw new Error(`/cart.js failed: ${response.status}`);
    return response.json();
  };

  // Shared headers for the drawer's OWN cart mutations. The internal_header
  // tells the cart-mutation watcher above to skip these — we already call
  // `this.update()` ourselves at the right moment.
  const internalCartHeaders = () => ({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    [internal_header_name]: internal_header_value,
  });

  const changeLine = async ({ id, quantity }) => {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'include',
      headers: internalCartHeaders(),
      body: JSON.stringify({ id, quantity }),
    });
    if (!response.ok) throw new Error(`/cart/change.js failed: ${response.status}`);
    return response.json();
  };

  const addLine = async ({ id, quantity = 1 }) => {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'include',
      headers: internalCartHeaders(),
      body: JSON.stringify({ items: [{ id, quantity }] }),
    });
    if (!response.ok) throw new Error(`/cart/add.js failed: ${response.status}`);
    return response.json();
  };

  const updateNote = async (note) => {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'include',
      headers: internalCartHeaders(),
      body: JSON.stringify({ note }),
    });
    if (!response.ok) throw new Error(`/cart/update.js failed: ${response.status}`);
    return response.json();
  };

  const fetchRecommendations = async (product_id) => {
    if (!product_id) return [];
    const url = new URL(recommendations_endpoint, window.location.origin);
    url.searchParams.set('product_id', String(product_id));
    url.searchParams.set('limit', String(recommendations_limit));
    url.searchParams.set('intent', recommendations_intent);
    const response = await fetch(url.toString(), {
      method: 'GET',
      credentials: 'include',
      headers: { 'Accept': 'application/json' },
    });
    if (!response.ok) return [];
    const data = await response.json();
    return Array.isArray(data.products) ? data.products : [];
  };

  // ---------- focus trap (minimal own implementation) ----------

  const getFocusableElements = (root) => {
    const selector = [
      'a[href]:not([disabled])',
      'button:not([disabled])',
      'input:not([disabled]):not([type="hidden"])',
      'textarea:not([disabled])',
      'select:not([disabled])',
      '[tabindex]:not([tabindex="-1"])',
    ].join(',');
    return Array.from(root.querySelectorAll(selector)).filter((el) => {
      return el.offsetParent !== null;
    });
  };

  const trapFocus = (panel, event) => {
    if (event.key !== 'Tab') return;
    const focusables = getFocusableElements(panel);
    if (focusables.length === 0) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  // ---------- web component ----------

  class UCartDrawerEl extends HTMLElement {
    constructor() {
      super();
      this.cart_state = null;
      this.swiper_instance = null;
      this.note_debounce = null;
      this.last_focused_before_open = null;
      // Loading-overlay bookkeeping: count concurrent mutations and track when
      // it first appeared, so we can enforce the 2 s minimum visibility.
      this.loading_depth = 0;
      this.loading_shown_at = 0;
      this.loading_hide_timer = null;
    }

    connectedCallback() {
      this.panel_el = this.querySelector('.ucdrawer__panel');
      this.body_el = this.querySelector('[data-ucdrawer-body]');
      this.items_el = this.querySelector('[data-ucdrawer-items]');
      this.empty_el = this.querySelector('[data-ucdrawer-empty]');
      this.count_el = this.querySelector('[data-ucdrawer-count]');
      this.footer_el = this.querySelector('[data-ucdrawer-footer]');
      this.subtotal_el = this.querySelector('[data-ucdrawer-subtotal]');
      this.shipping_cost_el = this.querySelector('[data-ucdrawer-shipping-cost]');
      this.total_el = this.querySelector('[data-ucdrawer-total]');
      this.shipping_bar_el = this.querySelector('[data-ucdrawer-shipping]');
      this.shipping_text_el = this.querySelector('[data-ucdrawer-shipping-text]');
      this.shipping_progress_el = this.querySelector('[data-ucdrawer-shipping-progress]');
      this.shipping_fill_el = this.querySelector('[data-ucdrawer-shipping-fill]');
      this.shipping_min_el = this.querySelector('[data-ucdrawer-shipping-min]');
      this.shipping_max_el = this.querySelector('[data-ucdrawer-shipping-max]');
      this.recommendations_el = this.querySelector('[data-ucdrawer-recommendations]');
      this.rec_list_el = this.querySelector('[data-ucdrawer-rec-list]');
      this.rec_dots_el = this.querySelector('[data-ucdrawer-rec-dots]');
      this.note_section_el = this.querySelector('[data-ucdrawer-note-section]');
      this.note_toggle_el = this.querySelector('[data-ucdrawer-note-toggle]');
      this.note_input_el = this.querySelector('[data-ucdrawer-note-input]');
      this.loading_el = this.querySelector('[data-ucdrawer-loading]');

      this.item_template = document.getElementById('ucdrawer-item-template');
      this.rec_template = document.getElementById('ucdrawer-rec-template');

      // Merchant-configured `shop.money_format` if present; empty string makes
      // `formatMoney` fall through to its Intl branch keyed by cart currency.
      this.money_format = this.dataset.moneyFormat || '';
      this.free_shipping_threshold = Number(this.dataset.freeShippingThreshold) || 0;
      this.shipping_estimate_default = Number(this.dataset.shippingEstimateDefault) || 0;
      // Localized strings pre-rendered by Liquid. The progress text uses an
      // __AMOUNT__ placeholder we swap in JS — Shopify's `{{ amount }}` would
      // have been HTML-escaped before reaching the dataset.
      this.text_free_shipping_progress = this.dataset.textFreeShippingProgress || '';
      this.text_free_shipping_reached = this.dataset.textFreeShippingReached || '';
      this.text_shipping_free = this.dataset.textShippingFree || '';

      this.bindEvents();
      this.update().catch((err) => console.error('uCartDrawer initial update failed:', err));
    }

    bindEvents() {
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-ucdrawer-close]')) {
          event.preventDefault();
          this.close();
          return;
        }
        // Consent gate: the absolutely-positioned guard sits over the checkout
        // buttons while the consent checkbox is unchecked. CSS removes it once
        // checked; here we just surface the error message on click.
        if (event.target.closest('[data-ucdrawer-guard]')) {
          const err = this.querySelector('[data-ucdrawer-consent-error]');
          if (err) err.classList.add('is-shown');
        }
      });

      // Hide the consent error as soon as the box is ticked.
      this.addEventListener('change', (event) => {
        const cb = event.target.closest('[data-ucdrawer-consent]');
        if (cb && cb.checked) {
          const err = this.querySelector('[data-ucdrawer-consent-error]');
          if (err) err.classList.remove('is-shown');
        }
      });

      this.items_el.addEventListener('click', (event) => this.handleItemAction(event));
      // Qty input — debounce while the user is typing (`input`), but fire
      // immediately when they leave the field or press Enter (`change`).
      this.items_el.addEventListener('input', (event) => this.handleQtyInputChange(event, { immediate: false }));
      this.items_el.addEventListener('change', (event) => this.handleQtyInputChange(event, { immediate: true }));
      this.note_toggle_el.addEventListener('click', () => this.toggleNote());
      this.note_input_el.addEventListener('input', () => this.scheduleNoteSave());
      this.rec_list_el.addEventListener('click', (event) => this.handleRecAdd(event));

      // Theme.js dispatches `flu:cart:updated` ~50ms after our own
      // mutations (via the `apps:product-added-to-cart` → cartUpdatedExternally
      // chain). Without this guard, we'd re-render the drawer a second time
      // on top of the one we just finished, causing visible re-flow jumps
      // (header height shifts, items list rebuilds, scrollbar appears /
      // disappears). Skip if we updated within the last 400ms.
      document.addEventListener('flu:cart:updated', () => {
        if (this.last_update_at && Date.now() - this.last_update_at < 400) return;
        this.update().catch(console.error);
      });

      // When the theme is configured to use the custom drawer, hijack every
      // click that would otherwise open the legacy flyout (or navigate to
      // /cart) and open this drawer instead. Delegation on `document` so it
      // also catches buttons that may be injected later (e.g. by Customizer
      // section rerenders).
      const cart_type = document.body && document.body.dataset && document.body.dataset.cartType;
      if (cart_type === 'custom-drawer') {
        document.addEventListener('click', (event) => {
          const trigger = event.target.closest('.js-cart-drawer-toggle, [aria-controls="cart-flyout-drawer"]');
          if (!trigger) return;
          // Let item-level quick-shop buttons go through their own flow —
          // they open the quick-add modal, not the cart drawer.
          if (trigger.hasAttribute('data-quick-add')) return;
          event.preventDefault();
          event.stopPropagation();
          this.open();
        }, true); // capture phase, so we win over theme.js's own listener
      }

      document.addEventListener('keydown', (event) => {
        if (!this.isOpen()) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
        } else {
          trapFocus(this.panel_el, event);
        }
      });
    }

    isOpen() {
      return this.classList.contains('ucdrawer--open');
    }

    open() {
      if (this.isOpen()) return;
      this.last_focused_before_open = document.activeElement;
      this.removeAttribute('hidden');
      requestAnimationFrame(() => {
        this.classList.add('ucdrawer--open');
        document.documentElement.classList.add(html_open_class);
        const focusables = getFocusableElements(this.panel_el);
        if (focusables.length > 0) focusables[0].focus();
        else this.panel_el.focus();
      });
    }

    close() {
      if (!this.isOpen()) return;
      this.classList.remove('ucdrawer--open');
      document.documentElement.classList.remove(html_open_class);
      setTimeout(() => {
        if (!this.isOpen()) this.setAttribute('hidden', '');
      }, 300);
      if (this.last_focused_before_open && typeof this.last_focused_before_open.focus === 'function') {
        this.last_focused_before_open.focus();
      }
    }

    // Refetches /cart.js and re-renders everything (count, items, summary,
    // shipping bar). Recommendations refresh only when the first cart item id
    // changed since last render — they're stable while the user shops.
    // Shows the loading overlay, keeps the panel uninteractive. Concurrent
    // mutations share the same overlay via a depth counter.
    showLoading() {
      this.loading_depth += 1;
      if (this.loading_depth === 1) {
        clearTimeout(this.loading_hide_timer);
        this.loading_shown_at = Date.now();
        this.classList.add('ucdrawer--loading');
        if (this.loading_el) this.loading_el.setAttribute('aria-hidden', 'false');
      }
    }

    // Schedules the overlay to fade out — but never before it's been
    // visible for `min_ms` (default 2 s), so quick mutations still get
    // a smooth, non-jarring transition.
    hideLoading(min_ms = 1000) {
      this.loading_depth = Math.max(0, this.loading_depth - 1);
      if (this.loading_depth !== 0) return;
      const elapsed = Date.now() - this.loading_shown_at;
      const remaining = Math.max(0, min_ms - elapsed);
      clearTimeout(this.loading_hide_timer);
      this.loading_hide_timer = setTimeout(() => {
        if (this.loading_depth === 0) {
          this.classList.remove('ucdrawer--loading');
          if (this.loading_el) this.loading_el.setAttribute('aria-hidden', 'true');
        }
      }, remaining);
    }

    async update() {
      this.showLoading();
      this.last_update_at = Date.now();
      try {
        const previous_first_item_id = this.cart_state?.items?.[0]?.product_id;
        const cart = await fetchCart();
        this.cart_state = cart;

        this.renderHeader(cart);
        this.renderItems(cart);
        this.renderSummary(cart);
        this.renderShippingBar(cart);
        this.renderNote(cart);

        const new_first_item_id = cart.items?.[0]?.product_id;
        if (new_first_item_id !== previous_first_item_id) {
          this.renderRecommendations(new_first_item_id).catch(console.error);
        }
      } finally {
        this.hideLoading();
      }
    }

    renderHeader(cart) {
      this.count_el.textContent = `(${cart.item_count})`;
    }

    renderItems(cart) {
      // Preserve scroll position across re-render. Wiping `items_el.innerHTML`
      // briefly collapses body height; the browser will clamp scrollTop to a
      // smaller scrollHeight and the user sees a jump when items come back.
      const saved_scroll_top = this.body_el ? this.body_el.scrollTop : 0;

      this.items_el.innerHTML = '';

      if (!cart.items || cart.items.length === 0) {
        this.empty_el.removeAttribute('hidden');
        this.footer_el.setAttribute('hidden', '');
        return;
      }

      this.empty_el.setAttribute('hidden', '');
      this.footer_el.removeAttribute('hidden');

      cart.items.forEach((item) => {
        const node = this.item_template.content.firstElementChild.cloneNode(true);
        node.dataset.lineKey = item.key;
        node.dataset.variantId = item.variant_id;

        const url_targets = node.querySelectorAll('[data-line-url]');
        url_targets.forEach((el) => { el.setAttribute('href', item.url); });

        const img_el = node.querySelector('[data-line-image]');
        if (item.featured_image && item.featured_image.url) {
          img_el.setAttribute('src', item.featured_image.url.replace(/(\.[a-z]+)(\?.*)?$/i, '_240x$1$2'));
          img_el.setAttribute('alt', item.title);
        } else {
          img_el.remove();
        }

        node.querySelector('[data-line-title]').textContent = item.product_title;
        node.querySelector('[data-line-price]').textContent = formatMoney(item.final_line_price, this.money_format, this.cart_state && this.cart_state.currency);

        const material = this.extractMaterial(item);
        const material_el = node.querySelector('[data-line-material]');
        if (material) {
          material_el.textContent = material;
        } else {
          material_el.remove();
        }

        const attributes = this.extractAttributes(item);
        const attributes_el = node.querySelector('[data-line-attributes]');
        if (attributes) {
          attributes_el.textContent = attributes;
        } else {
          attributes_el.remove();
        }

        const qty_input = node.querySelector('[data-line-qty]');
        qty_input.value = String(item.quantity);

        this.items_el.appendChild(node);
      });

      // Inventory caps are loaded async — we don't want to block the initial
      // render. Each input keeps `max="50"` until /products/{handle}.js comes
      // back with the variant's real inventory_quantity.
      this.applyInventoryCaps(cart).catch((err) => {
        console.warn('uCartDrawer inventory fetch failed:', err);
      });

      if (this.body_el) this.body_el.scrollTop = saved_scroll_top;
    }

    // For every cart line, fetch its product once (deduped by handle) and set
    // the qty input's `max` to `min(50, inventory_quantity)`. Variants with
    // inventory_management = null (untracked) keep the 50 cap.
    async applyInventoryCaps(cart) {
      const handles = [...new Set(cart.items.map((item) => item.handle))];
      const product_results = await Promise.all(
        handles.map((handle) => fetch(`/products/${handle}.js`, {
          credentials: 'include',
          headers: { 'Accept': 'application/json' },
        }).then((r) => r.ok ? r.json() : null).catch(() => null))
      );

      const variant_max = new Map();
      product_results.forEach((product) => {
        if (!product || !Array.isArray(product.variants)) return;
        product.variants.forEach((variant) => {
          const tracked = variant.inventory_management !== null
            && variant.inventory_policy !== 'continue';
          const cap = tracked
            ? Math.max(1, Math.min(50, variant.inventory_quantity ?? 50))
            : 50;
          variant_max.set(variant.id, cap);
        });
      });

      this.items_el.querySelectorAll('.ucdrawer__item').forEach((item_el) => {
        const variant_id = Number(item_el.dataset.variantId);
        const cap = variant_max.get(variant_id);
        if (!cap) return;
        const input = item_el.querySelector('[data-line-qty]');
        if (input) input.max = String(cap);
      });
    }

    extractMaterial(item) {
      const options = Array.isArray(item.options_with_values) ? item.options_with_values : [];
      const match = options.find((opt) => {
        const name = String(opt.name || '').toLowerCase();
        return name === 'materiał' || name === 'material';
      });
      return match ? match.value : '';
    }

    // Every selected option EXCEPT material — for the secondary attributes
    // line under the material badge. Skips Shopify's synthetic Title /
    // Default Title pair that products without real options carry.
    extractAttributes(item) {
      const options = Array.isArray(item.options_with_values) ? item.options_with_values : [];
      const pairs = options.filter((opt) => {
        const name = String(opt.name || '').toLowerCase();
        if (name === 'materiał' || name === 'material') return false;
        if (name === 'title' && String(opt.value || '') === 'Default Title') return false;
        return opt.value;
      });
      return pairs.map((opt) => `${opt.name}: ${opt.value}`).join(', ');
    }

    renderSummary(cart) {
      const currency = this.cart_state && this.cart_state.currency;
      this.subtotal_el.textContent = formatMoney(cart.items_subtotal_price ?? cart.total_price, this.money_format, currency);

      const shipping_row = this.shipping_cost_el.closest('.ucdrawer__summary-row');
      if (this.shipping_estimate_default <= 0) {
        if (shipping_row) shipping_row.hidden = true;
        this.total_el.textContent = formatMoney(cart.total_price, this.money_format, currency);
        return;
      }
      if (shipping_row) shipping_row.hidden = false;

      // Mirror renderShippingBar exactly so "free shipping reached" in the
      // progress bar and "Bezpłatna" in the summary flip on the same cart value.
      const threshold_cents = this.free_shipping_threshold * 100;
      const subtotal_cents = cart.items_subtotal_price ?? cart.total_price ?? 0;
      const qualifies_for_free = this.free_shipping_threshold > 0 && subtotal_cents >= threshold_cents;

      if (qualifies_for_free) {
        this.shipping_cost_el.textContent = this.text_shipping_free;
        this.total_el.textContent = formatMoney(cart.total_price, this.money_format, currency);
      } else {
        const shipping_cents = this.shipping_estimate_default * 100;
        this.shipping_cost_el.textContent = formatMoney(shipping_cents, this.money_format, currency);
        this.total_el.textContent = formatMoney(cart.total_price + shipping_cents, this.money_format, currency);
      }
    }

    renderShippingBar(cart) {
      if (this.free_shipping_threshold <= 0 || !cart.items || cart.items.length === 0) {
        this.shipping_bar_el.setAttribute('hidden', '');
        return;
      }
      this.shipping_bar_el.removeAttribute('hidden');

      const threshold_cents = this.free_shipping_threshold * 100;
      const subtotal_cents = cart.items_subtotal_price ?? cart.total_price ?? 0;
      const remaining_cents = Math.max(0, threshold_cents - subtotal_cents);
      const progress_percent = Math.min(100, Math.round((subtotal_cents / threshold_cents) * 100));

      if (remaining_cents === 0) {
        this.shipping_text_el.innerHTML = this.text_free_shipping_reached;
        // Detach progress row entirely — we keep the JS reference so we can
        // re-attach it if the cart later drops back below the threshold.
        if (this.shipping_progress_el.parentNode) this.shipping_progress_el.remove();
        return;
      }

      if (!this.shipping_progress_el.parentNode) {
        this.shipping_bar_el.appendChild(this.shipping_progress_el);
      }
      const remaining_formatted = formatMoney(remaining_cents, this.money_format, this.cart_state && this.cart_state.currency);
      this.shipping_text_el.innerHTML = this.text_free_shipping_progress.replace('__AMOUNT__', remaining_formatted);

      this.shipping_fill_el.style.width = `${progress_percent}%`;
      this.shipping_progress_el.setAttribute('aria-valuenow', String(progress_percent));
      this.shipping_min_el.textContent = formatMoney(subtotal_cents, this.money_format, this.cart_state && this.cart_state.currency);
      this.shipping_max_el.textContent = formatMoney(threshold_cents, this.money_format, this.cart_state && this.cart_state.currency);
    }

    renderNote(cart) {
      if (!cart.items || cart.items.length === 0) {
        this.note_section_el.setAttribute('hidden', '');
        return;
      }
      this.note_section_el.removeAttribute('hidden');
      if (this.note_input_el.value !== (cart.note || '')) {
        this.note_input_el.value = cart.note || '';
      }
    }

    async renderRecommendations(seed_product_id) {
      if (!seed_product_id) {
        this.recommendations_el.setAttribute('hidden', '');
        return;
      }

      const products = await fetchRecommendations(seed_product_id);
      if (products.length === 0) {
        this.recommendations_el.setAttribute('hidden', '');
        return;
      }

      this.rec_list_el.innerHTML = '';
      products.forEach((product) => {
        const node = this.rec_template.content.firstElementChild.cloneNode(true);
        node.querySelectorAll('[data-rec-url]').forEach((el) => el.setAttribute('href', product.url));

        const img_el = node.querySelector('[data-rec-image]');
        if (product.featured_image) {
          img_el.setAttribute('src', product.featured_image);
          img_el.setAttribute('alt', product.title);
        } else {
          img_el.remove();
        }

        node.querySelector('[data-rec-title]').textContent = product.title;

        // Leave the div in DOM even when empty — matches product-item.liquid
        // and lets the `:empty { display: none }` CSS rule handle visibility.
        const materials = this.extractMaterialsFromProduct(product);
        node.querySelector('[data-rec-material]').textContent = materials;

        node.querySelector('[data-rec-price]').textContent = formatMoney(product.price, this.money_format, this.cart_state && this.cart_state.currency);

        // Decide: direct add vs let theme's quick-add modal handle it.
        //  • 0 available variants → disable the button.
        //  • 1 available variant → set variantId so our handler fast-adds.
        //  • >1 available variants → set `data-quick-add` so theme.js's own
        //    delegated listener (on document) opens the variant picker.
        //    Our handler will see the attribute and step out of the way.
        const available_variants = (product.variants || []).filter((v) => v.available);
        const add_btn = node.querySelector('[data-rec-add]');
        if (available_variants.length === 0) {
          add_btn.setAttribute('disabled', '');
        } else if (available_variants.length === 1) {
          add_btn.dataset.variantId = available_variants[0].id;
        } else {
          add_btn.setAttribute('data-quick-add', product.handle);
        }

        this.rec_list_el.appendChild(node);
      });

      this.recommendations_el.removeAttribute('hidden');
      this.initRecommendationsSwiper();
    }

    extractMaterialsFromProduct(product) {
      const options = Array.isArray(product.options) ? product.options : [];
      // `/recommendations/products.json` returns `options` as objects
      // ({name, position, values}); other endpoints return plain strings.
      // Handle both.
      const idx = options.findIndex((opt) => {
        const name = typeof opt === 'string' ? opt : (opt && opt.name);
        const lc = String(name || '').toLowerCase();
        return lc === 'materiał' || lc === 'material';
      });
      if (idx === -1) return '';

      // Prefer the option's own `values` array (objects case) — it's the
      // canonical, admin-ordered list. Fall back to scanning variants when
      // we only have option names.
      const opt = options[idx];
      if (opt && Array.isArray(opt.values) && opt.values.length > 0) {
        return opt.values.filter(Boolean).join(' | ');
      }

      const variants = product.variants || [];
      const seen = new Set();
      const values = [];
      variants.forEach((variant) => {
        const value = variant[`option${idx + 1}`];
        if (value && !seen.has(value)) {
          seen.add(value);
          values.push(value);
        }
      });
      return values.join(' | ');
    }

    initRecommendationsSwiper() {
      if (this.swiper_instance) {
        this.swiper_instance.destroy(true, true);
        this.swiper_instance = null;
      }
      const swiper_root = this.recommendations_el.querySelector('.swiper');
      if (!swiper_root || typeof window.Swiper === 'undefined') return;

      this.swiper_instance = new window.Swiper(swiper_root, {
        slidesPerView: 2.4,
        spaceBetween: 8,
        breakpoints: {
          480: { slidesPerView: 3, spaceBetween: 12 },
        },
        a11y: {
          enabled: true,
          paginationBulletMessage: 'Slide {{index}}',
        },
        on: {
          // Custom dots — the Swiper bundle in this theme doesn't include the
          // pagination module, so we hand-roll dots that mirror activeIndex.
          init: (swiper) => this.renderRecommendationDots(swiper),
          slideChange: (swiper) => this.updateRecommendationDots(swiper),
        },
      });
    }

    renderRecommendationDots(swiper) {
      this.rec_dots_el.innerHTML = '';
      const total_groups = Math.max(1, swiper.slides.length - Math.ceil(swiper.params.slidesPerView) + 1);
      for (let i = 0; i < total_groups; i += 1) {
        const dot = document.createElement('li');
        dot.className = 'ucdrawer__rec-dot';
        if (i === swiper.activeIndex) dot.classList.add('ucdrawer__rec-dot--active');
        dot.dataset.index = String(i);
        dot.addEventListener('click', () => swiper.slideTo(i));
        this.rec_dots_el.appendChild(dot);
      }
    }

    updateRecommendationDots(swiper) {
      const dots = this.rec_dots_el.querySelectorAll('.ucdrawer__rec-dot');
      dots.forEach((dot, idx) => {
        dot.classList.toggle('ucdrawer__rec-dot--active', idx === swiper.activeIndex);
      });
    }

    async handleItemAction(event) {
      const target = event.target;
      const item_el = target.closest('.ucdrawer__item');
      if (!item_el) return;

      const line_key = item_el.dataset.lineKey;
      const qty_input = item_el.querySelector('[data-line-qty]');
      const current_qty = parseInt(qty_input ? qty_input.value : '0', 10) || 0;
      const max_qty = qty_input ? parseInt(qty_input.max, 10) || Infinity : Infinity;

      if (target.closest('[data-line-qty-increment]')) {
        const next = Math.min(max_qty, current_qty + 1);
        if (next === current_qty) return;
        await this.changeAndUpdate({ id: line_key, quantity: next });
      } else if (target.closest('[data-line-qty-decrement]')) {
        const next = Math.max(0, current_qty - 1);
        await this.changeAndUpdate({ id: line_key, quantity: next });
      } else if (target.closest('[data-line-remove]')) {
        await this.changeAndUpdate({ id: line_key, quantity: 0 });
      }
    }

    // User typed / pasted a number into the qty input.
    //   - `input` event (every keystroke) → debounced 2 s so we don't fire
    //     a POST on every digit while they're still typing.
    //   - `change` event (blur, Enter) → immediate. Any pending debounce
    //     is cancelled so we don't double-fire.
    // In both cases the value is clamped to [1, max] before sending.
    handleQtyInputChange(event, { immediate } = { immediate: false }) {
      const input = event.target.closest('[data-line-qty]');
      if (!input || input.tagName !== 'INPUT') return;
      const item_el = input.closest('.ucdrawer__item');
      if (!item_el) return;

      const line_key = item_el.dataset.lineKey;
      const min_qty = 1;
      const max_qty = parseInt(input.max, 10) || Infinity;
      let next = parseInt(input.value, 10);
      if (!Number.isFinite(next) || next < min_qty) next = min_qty;
      if (next > max_qty) next = max_qty;

      // For `change` (blur) we reflect the clamped value back so the user
      // sees what we're sending. For `input` we leave their text alone so
      // we don't fight the cursor while they're still typing.
      if (immediate) input.value = String(next);

      clearTimeout(input.__ucd_change_timer);
      if (immediate) {
        this.changeAndUpdate({ id: line_key, quantity: next });
      } else {
        input.__ucd_change_timer = setTimeout(() => {
          input.value = String(next);
          this.changeAndUpdate({ id: line_key, quantity: next });
        }, 2000);
      }
    }

    async changeAndUpdate({ id, quantity }) {
      this.showLoading();
      try {
        await changeLine({ id, quantity });
        await this.update();
        this.notifyExternal();
      } catch (err) {
        console.error('uCartDrawer change failed:', err);
      } finally {
        this.hideLoading();
      }
    }

    async handleRecAdd(event) {
      const add_btn = event.target.closest('[data-rec-add]');
      if (!add_btn) return;
      // Always prevent the parent <a> from navigating to the product page —
      // even when we're handing off to quick-add, the click would otherwise
      // also walk us out of the drawer.
      event.preventDefault();

      // Multi-variant: theme.js's document-level [data-quick-add] delegate
      // handles this click as the same event bubbles past us. We just step
      // aside. Drawer stays open underneath; the fetch monkey-patch above
      // refreshes it when quick-add's POST /cart/add.js succeeds.
      if (add_btn.hasAttribute('data-quick-add')) return;

      const variant_id = Number(add_btn.dataset.variantId);
      if (!variant_id) return;
      this.showLoading();
      let added_ok = false;
      try {
        add_btn.disabled = true;
        await addLine({ id: variant_id, quantity: 1 });
        await this.update();
        this.notifyExternal();
        added_ok = true;
      } catch (err) {
        console.error('uCartDrawer recommendation add failed:', err);
      } finally {
        add_btn.disabled = false;
        this.hideLoading();
      }

      // After a successful quick-add the newly-added item sits at the top of
      // the items list — scroll the body up so the user sees confirmation
      // instead of being left looking at the recommendation row.
      if (added_ok) this.scrollBodyToTop();
    }

    scrollBodyToTop() {
      if (!this.body_el) return;
      this.body_el.scrollTo({ top: 0, behavior: 'smooth' });
    }

    toggleNote() {
      const expanded = this.note_toggle_el.getAttribute('aria-expanded') === 'true';
      const next = !expanded;
      // Only the toggle button changes — CSS drives the slide animation off
      // `aria-expanded` on the toggle (using the adjacent-sibling selector).
      this.note_toggle_el.setAttribute('aria-expanded', String(next));
      if (next) {
        // Wait for the slide-down to finish before focusing — otherwise the
        // browser jumps to the textarea position mid-animation.
        setTimeout(() => this.note_input_el.focus(), 250);
      }
    }

    scheduleNoteSave() {
      clearTimeout(this.note_debounce);
      this.note_debounce = setTimeout(() => {
        updateNote(this.note_input_el.value || '').catch(console.error);
      }, 600);
    }

    notifyExternal() {
      // We only dispatch `apps:product-added-to-cart`. Theme.js's handler
      // (`cartUpdatedExternally`, theme.js:2355) re-fetches /cart.js, updates
      // the header badge AND dispatches `flu:cart:updated` itself (line 2380)
      // — so any app/section listening to flu:cart:updated still gets it,
      // just via the canonical chain. Dispatching flu:cart:updated ourselves
      // here triggered our own listener (line 869) and caused redundant
      // re-renders.
      document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
    }
  }

  if (!customElements.get(tag_name)) {
    customElements.define(tag_name, UCartDrawerEl);
  }

  const getEl = () => document.querySelector(tag_name);

  return {
    open: () => getEl()?.open(),
    close: () => getEl()?.close(),
    update: () => getEl()?.update(),
    scrollBodyToTop: () => getEl()?.scrollBodyToTop(),
  };

})();


/* Quick-add modal — variant popup */
(() => {

  const handleVariantPopupClick = (event) => {
    const trigger = event.target.closest('[data-variant-popup-trigger]');
    if (!trigger) return;

    const quick_add = trigger.closest('.quick-add[data-quick-add-modal]');
    if (!quick_add) return;

    event.preventDefault();

    const content_id = trigger.dataset.modalContentId;
    if (!content_id) return;

    const content_el = quick_add.querySelector('#' + content_id);
    if (!content_el) return;

    const theme_modal = document.querySelector('#modal[data-modal]');
    if (!theme_modal) return;

    const theme_modal_content = theme_modal.querySelector('.modal__content');
    if (!theme_modal_content) return;

    theme_modal_content.innerHTML = '';
    theme_modal_content.appendChild(content_el.cloneNode(true));

    // Mirror theme.js's `_wrapTables` (only runs on main-product container at
    // init — not in our context). CSS rule `.rte table { opacity: 0 }` keeps
    // tables invisible until they're wrapped in `<div class="rte-table">`
    // which then triggers `.rte-table table { opacity: 1 }`.
    theme_modal_content.querySelectorAll('table').forEach((table) => {
      if (table.parentElement && table.parentElement.classList.contains('rte-table')) return;
      const wrapper = document.createElement('div');
      wrapper.classList.add('rte-table');
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });

    theme_modal.classList.add('is-visible');
    theme_modal.classList.add('is-over-quick-add');

    // Backdrop click → close. Theme.js's modal init doesn't listen for clicks
    // on the modal element itself — it relies on a separate drawer overlay
    // (fires `drawerOverlay:hiding` via internal pubsub) which we bypass.
    // So we wire it ourselves: click landing on .modal but outside .modal__inner
    // removes is-visible.
    const backdropClickHandler = (event_inner) => {
      const modal_inner = theme_modal.querySelector('.modal__inner');
      if (modal_inner && !modal_inner.contains(event_inner.target)) {
        theme_modal.classList.remove('is-visible');
      }
    };
    theme_modal.addEventListener('click', backdropClickHandler);

    // Clean up the z-index bump AND the backdrop listener when is-visible is
    // removed (by close button, Esc, or our backdrop click above).
    const observer = new MutationObserver(() => {
      if (!theme_modal.classList.contains('is-visible')) {
        theme_modal.classList.remove('is-over-quick-add');
        theme_modal.removeEventListener('click', backdropClickHandler);
        observer.disconnect();
      }
    });
    observer.observe(theme_modal, { attributes: true, attributeFilter: ['class'] });
  };

  document.addEventListener('click', handleVariantPopupClick);

  // Wash-click priority: when the variant popup modal is open on top of
  // quick-add, clicking quick-add's wash should close the popup FIRST
  // (instead of closing quick-add itself which is theme.js's default).
  // We intercept on capture phase to beat theme.js's direct listener on
  // the wash element.
  document.addEventListener('click', (event) => {
    if (!event.target.closest('.quick-add__wash')) return;
    const theme_modal = document.querySelector('#modal[data-modal]');
    if (!theme_modal || !theme_modal.classList.contains('is-visible')) return;
    event.stopImmediatePropagation();
    event.preventDefault();
    theme_modal.classList.remove('is-visible');
  }, { capture: true });

})();


/* Quick-add modal — reactive subtitle.
   The modal's Liquid renders the initial "Materiał" option value of the
   selected variant. When the user picks a different variant in the dropdown,
   theme.js dispatches `flu:product:variant-change` — we listen and refresh
   the subtitle text without a reload.
   Scoped to the quick-add modal so it doesn't fire for PDP variant changes. */
(() => {

  const product_cache = new Map();

  const findMaterialName = (name) => {
    const lc = String(name || '').toLowerCase();
    return lc === 'materiał' || lc === 'material';
  };

  const setSubtitle = (subtitle_el, variant, product_data) => {
    // Fast path — `variant.options_with_values` (cart line shape) gives us
    // name+value pairs directly. Some theme events ship this.
    if (Array.isArray(variant.options_with_values)) {
      const match = variant.options_with_values.find((opt) => findMaterialName(opt.name));
      subtitle_el.textContent = match ? match.value : '';
      return;
    }

    // Slow path — variant only has option1/option2/option3. Need option
    // names from the product to know which index is "Materiał".
    if (!product_data || !Array.isArray(product_data.options)) {
      subtitle_el.textContent = '';
      return;
    }
    const idx = product_data.options.findIndex((opt) => {
      const name = typeof opt === 'string' ? opt : (opt && opt.name);
      return findMaterialName(name);
    });
    if (idx === -1) {
      subtitle_el.textContent = '';
      return;
    }
    subtitle_el.textContent = variant[`option${idx + 1}`] || '';
  };

  const handleVariantChange = (event) => {
    const modal = document.querySelector('.quick-add[data-quick-add-modal]');
    if (!modal || !modal.contains(event.target)) return;

    const variant = event.detail && event.detail.variant;
    if (!variant) return;

    const subtitle_el = modal.querySelector('[data-quick-add-subtitle]');
    if (!subtitle_el) return;

    // Quick path attempt first — sometimes resolves with no fetch.
    if (Array.isArray(variant.options_with_values)) {
      setSubtitle(subtitle_el, variant);
      return;
    }

    const handle_el = modal.querySelector('[data-product-handle]');
    const handle = handle_el && handle_el.dataset.productHandle;
    if (!handle) return;

    if (product_cache.has(handle)) {
      setSubtitle(subtitle_el, variant, product_cache.get(handle));
      return;
    }

    fetch(`/products/${handle}.js`, {
      credentials: 'include',
      headers: { 'Accept': 'application/json' },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (!data) return;
        product_cache.set(handle, data);
        setSubtitle(subtitle_el, variant, data);
      })
      .catch(() => {});
  };

  document.addEventListener('flu:product:variant-change', handleVariantChange);

})();
